import {
  blockedUsers,
  toggleUserBlocked,
} from '~/frontend/store.js'

let filterOn = true;

export const hideBlockedPosts = () => {
  const blockedUsernames = blockedUsers();
  const postUsernameBs = document.querySelectorAll('body > #Content > table > tbody > tr > td:last-child .ljuser b');

  Array.from(postUsernameBs).forEach(b => {
    if (blockedUsernames.indexOf(b.textContent) !== -1) b.closest('tr').className = '_hidden';
    else b.closest('tr').removeAttribute('class');
  });
};

export const ensureFilterButtons = () => {
  const allPosts = document.querySelectorAll('body > #Content > table > tbody > tr');

  allPosts.forEach(tr => {
    const ljuser = tr.querySelector('.ljuser');
    ljuser.parentNode.querySelector('._block-button')?.remove();

    const blockButton = document.createElement('span');
    blockButton.className = '_block-button';
    blockButton.innerHTML = '🚫';

    blockButton.onclick = (e) => {
      toggleUserBlocked(e.target.previousElementSibling.querySelector('b').textContent);
      hideBlockedPosts();

      return false;
    };

    ljuser.nextSibling.nextSibling.before(blockButton);
  });
};

export const toggleFilter = (e) => {
  filterOn = !filterOn;

  if (filterOn) document.body.removeAttribute('class');
  else document.body.className = '_show-filtered';

  e.preventDefault();
};

export const isPostBlocked = (post) => {
  const username = post.url.split('/')[4];
  return blockedUsers().includes(username);
};
